import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-grid-system';
import Layout from '../../../templates/Layout';
import { Helmet } from 'react-helmet';
import H1 from '../../../atoms/title/H1';
import Panel from '../../../atoms/Panel';
import H3 from '../../../atoms/title/H3';
import UserInfo from '../../../molecules/form/UserInfo';
import Paragraph from '../../../atoms/Paragraph';
import Button from '../../../atoms/Button';
import SendEmail from '../../../atoms/icons/SendEmail';
import styled from 'styled-components';
import Cross from '../../../atoms/icons/Cross';
import Notice from '../../../molecules/Notice';
import { useForm } from '@inertiajs/react';
export const iconStyle = `
    fill: white;
`;
const _SendMail = styled(SendEmail) `
    ${iconStyle};
    fill: white;
    margin-left: 5px;
`;
const _Cross = styled(Cross) `
    ${iconStyle};
`;
const _Wrapper = styled.div `
    display: flex;
    flex-direction: column;
    height: 100%;
`;
const GetUser = ({ notice, userInfo, emailDomain, }) => {
    const { t } = useTranslation();
    const { patch } = useForm({});
    const [processingPasswordReset, setProcessingPasswordReset,] = useState(false);
    const [processingDeleteUser] = useState(false);
    const [processingUpdateUser, setProcessingUpdateUser] = useState(false);
    const [noticeState, setNoticeState] = useState(notice);
    useEffect(() => {
        setNoticeState(notice);
    }, [notice]);
    const handleSendPasswordResetSubmit = (e) => {
        setProcessingPasswordReset(true);
        e.preventDefault();
        try {
            patch(`/gebruikers/${userInfo.id}/wachtwoord-reset`, {
                onSuccess: () => {
                    setProcessingPasswordReset(false);
                },
            });
        }
        catch (e) {
            setNoticeState({
                type: 'error',
                text: t('add_user.default_error_notice'),
                title: 'Fout',
            });
            setProcessingPasswordReset(false);
        }
    };
    return (_jsxs(Layout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('users.title') }) }), _jsx(H1, { "data-testid": "title", children: t('users.title') }), noticeState && _jsx(Notice, { ...noticeState }), _jsx(Row, { children: _jsx(Col, { sm: 12, children: _jsx(Panel, { children: _jsxs(Row, { children: [_jsx(Col, { sm: 6, children: _jsx(_Wrapper, { children: _jsx(UserInfo, { userInfo: userInfo, emailDomain: emailDomain, disabled: processingDeleteUser ||
                                                processingPasswordReset, setProcessingUpdateUser: setProcessingUpdateUser }) }) }), _jsx(Col, { sm: 1 }), _jsx(Col, { sm: 5, children: _jsxs(_Wrapper, { children: [_jsx(H3, { children: t('users.password_title') }), _jsx(Paragraph, { children: t('users.send_password_reset_text') }), _jsx("form", { method: 'patch', onSubmit: handleSendPasswordResetSubmit, children: _jsx(Button, { tertiary: true, icon: _jsx(_SendMail, {}), isLoading: processingPasswordReset, disabled: processingDeleteUser ||
                                                        processingUpdateUser ||
                                                        userInfo.is_deactivated, children: t('users.send_password_reset_button') }) })] }) })] }) }) }) })] }));
};
export default GetUser;
